import React, { forwardRef } from 'react'

import { Box, Card, CardActions, CardContent, Dialog, Icon, IconButton } from '@popmenu/common-ui'
import { CheckCircle, Error as ErrorIcon, Info, Warning, X as XIcon } from '@popmenu/web-icons'
import { Button } from '../Button'
import { AlertDialogProps } from './AlertDialogProps'
import { useAlertDialogStyles } from './AlertDialogStyles'

const severityIcons: Record<Extract<AlertDialogProps, 'severity'>, string> = {
  info: Info,
  error: ErrorIcon,
  warning: Warning,
  success: CheckCircle,
}

export const AlertDialog = forwardRef<HTMLDivElement, AlertDialogProps>((props, ref) => {
  const {
    cancelButtonText = 'cancel',
    hideCancelButton = false,
    children,
    labelId,
    descriptionId,
    severity = 'info',
    proceedButtonText = 'proceed',
    disabled = false,
    onClose,
    onCancel,
    onProceed,
    ...DialogProps
  } = props
  const classes = useAlertDialogStyles(props)
  return (
    <Dialog ref={ref} classes={{ paper: classes.root }} maxWidth="sm" fullWidth={true} {...DialogProps}>
      <Card
        classes={{ root: classes.card }}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={labelId}
        aria-describedby={descriptionId}
      >
        <IconButton className={classes.cancelIcon} onClick={onClose} disabled={disabled}>
          <Icon icon={XIcon} />
        </IconButton>
        <CardContent>
          <Box display="flex">
            {/* @ts-expect-error - todo. */}
            <Icon className={classes.icon} color={severity} icon={severityIcons[severity]} />
            <Box pl={2} pr={3}>
              {children}
            </Box>
          </Box>
        </CardContent>
        <CardActions classes={{ root: classes.cardActions }}>
          {!hideCancelButton && (
            <Button onClick={onCancel} disabled={disabled} variant="ghost">
              {cancelButtonText}
            </Button>
          )}
          <Button onClick={onProceed} loading={disabled} variant={severity}>
            {proceedButtonText}
          </Button>
        </CardActions>
      </Card>
    </Dialog>
  )
})

AlertDialog.displayName = 'AlertDialog'
